<script>
	export let contents;
	export let hash = undefined;
	export let state = undefined;
	export let fn = () => {};
	export let raf = false;
	function click(e) {
		fn();
		state = Number(e.srcElement.value);
		if(typeof hash === 'string') {
			if(raf) {
				requestAnimationFrame(() => location.hash = hash);
			} else {
				location.hash = hash;
			}
		}
	}
	export let style;
	export let animate = false;
	if(animate) {
		setTimeout(() => {
			elements[0].style.width = null;
			setTimeout(() => contents[0] = animate, 150);
		}, 10);
	}
	let elements = [];
	export let active = true;
	export let id = ''
</script>

<style>
	button {
		color: white;
		font-size: 1.4em;
		font-weight: 700;
		width: min(20em, 80vw);
		padding-top: .75em;
		padding-bottom: .75em;
		margin: 1em;
		background-color: rgb(0, 107, 166);
		letter-spacing: .1em;
		text-align: center;
		text-transform: uppercase;
		transition: all 200ms;
		border: 2px solid rgb(0, 107, 166);
		border-radius: 3px;
	}
	button:hover {
		opacity: .7;
	}
	.active {
		color: rgb(0, 107, 166);
		background: white;
		opacity: .8;
	}	
</style>

{#each contents as content, i}
	<button {id} bind:this={elements[i]} {style} class:active={active && i === state} on:click|preventDefault|stopPropagation={click} type="button" value={i}>{@html content}</button>
{/each}